import React from 'react';
import TrailType from "types/TrailType";
import {TrailWaypointFormData} from "types/TrailWaypoint";
import WaypointEditor from "./WaypointEditor";
import Disclosure from "components/Disclosure";
import {AnyMedia} from "types/MediaFile";
import {TrailAdvisory} from "types/TrailAdvisory";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {DotsVerticalIcon} from "@heroicons/react/solid";
import {Offer} from "../../../types/Offer";

// Types ----

type WaypointListItemProps = {
  id: string | number
  name: string
  trailType?: TrailType
  trailIsCircuit?: boolean
  waypoint: TrailWaypointFormData
  offers: Array<Offer>
  media: Array<AnyMedia>
  advisories: Array<TrailAdvisory>
}

// Component ----

function WaypointListItem({id, name, trailType, trailIsCircuit, waypoint, offers, media, advisories}: WaypointListItemProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id});

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const title = (<>
    {trailType === TrailType.GOLF ? 'Hole' : 'Waypoint'} {Number(waypoint.order) + 1}: <span className="font-normal">{waypoint.name}</span>
  </>)

  const handle = (
    <div className="flex items-center cursor-grab active:cursor-grabbing -space-x-2" {...attributes} {...listeners}>
      <DotsVerticalIcon className="h-4 w-4"/>
      <DotsVerticalIcon className="h-4 w-4"/>
    </div>
  )

  return (
    <div ref={setNodeRef} style={style}>
      <Disclosure
        name={title}
        defaultOpen={typeof waypoint.id === 'string'}
        dragHandle={handle}
        isDragging={isDragging}
      >
      <WaypointEditor
          name={name}
          index={Number(waypoint.order)}
          trailType={trailType}
          trailIsCircuit={trailIsCircuit}
          media={media}
          offers={offers}
          advisories={advisories}
        />
      </Disclosure>
    </div>
  );
}

export default WaypointListItem;